// extracted by mini-css-extract-plugin
export var column = "_tx-0";
export var divider = "_tx-2";
export var timePicker = "_tx-1";